module.exports = __webpack_public_path__ + "static/media/up-arrow.a1434859.svg";